import React from 'react'
import AdminCategoryList from '../components/AdminCategoryList'
import BannerProduct from '../components/BannerProduct'
import { useNavigate } from 'react-router-dom'
import ROLE from '../common/role'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useState } from 'react'
import { AiOutlineLoading3Quarters } from 'react-icons/ai'
import AdminCosmeticHorizontalCardProduct from '../components/AdminCosmeticHorizontalCardProduct'
import NotificationBar from '../components/NotificationBar'


const AdminCosmeticHome = () => {
  const user = useSelector(state => state?.user?.user);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  useEffect(() => {
    setLoading(true);
    const loadingTimeout = setTimeout(() => {
      
      setLoading(false);
      navigate("/");
    }, 10000); 

    if (user) {
        if (user?.role !== ROLE.ADMIN ) {
          
          navigate("/");
          setLoading(false);
        } 
        else if(user?.type==="Medicine"){
          navigate('/admin-home')
          setLoading(false);
  
        }
        else if(user?.type==="Admin"){
          navigate('/admin-panel/all-users');
          setLoading(false);
  
        }
        else {
          setLoading(false);
          clearTimeout(loadingTimeout)
        }
      } 

    // Clear the timeout when the component unmounts or the effect is rerun
    return () => clearTimeout(loadingTimeout);
  }, [user, navigate]);

  
  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <AiOutlineLoading3Quarters className="animate-spin text-6xl text-blue-500" />
      </div>
    );
  }

  return (
    
      <div className="home-page">
            <NotificationBar/>
            <div>    
      <BannerProduct/>
      <AdminCategoryList userType={"Cosmetic"}/>
      <AdminCosmeticHorizontalCardProduct userType={"Cosmetic"} status={"New Arrival"} heading={"منتجات حديثة الوصول"}/>
      <AdminCosmeticHorizontalCardProduct userType={"Cosmetic"} status={"Promo Pack"} heading={"العروض المجمعة"}/>
      <AdminCosmeticHorizontalCardProduct userType={"Cosmetic"} status={"Sale"} heading={"التخفيضات"}/>  
    </div>
    </div>
  )
}

export default AdminCosmeticHome

